import React, { useMemo, useState } from 'react';

const MaskContext = React.createContext({
  showMask: false,
  onShowMaskChange: () => {},
});

const MaskProvider = ({ children }: any) => {
  const [showMask, setShowMask] = useState(false);

  const handleMaskChange = () => {
    setShowMask(!showMask);
  };

  const contextValue = useMemo(() => ({
    showMask,
    onShowMaskChange: handleMaskChange,
  }), [showMask]);

  return (
    <MaskContext.Provider value={contextValue}>
      {children}
    </MaskContext.Provider>
  );
};

export { MaskProvider };
export default MaskContext;
